<section class="main-box questionnaire-container">
  <div class="gs align-left wrap">

    <div class="holder">
      <i class="ae ae-left cursor-pointer m-r-md hide-sm hide-xs" (click)="goBack()">
      </i>
      <b>
        {{ ("questionnaire."  + questionnaireType)  | translate }} ({{ questionList.length }})
      </b>

      <div class="remove-holder" *ngIf="questionList.length">
        <i class="ae ae-recycle-bin cursor-pointer m-r-md hide-sm hide-xs text-right" (click)="deleteAllConfirm()">
        </i>
      </div>
    </div>
    
    <div class="lay" *ngIf="!questionList.length">
      <button mat-raised-button 
        #addQuestion0
        class="add-button m-t-md hide-md hide-lg" 
        color="primary" 
        (click)="openQuestionAddModal()">
        <i class="ae ae-plus-bolt"></i>
        {{ "questionnaire.addQuestion" | translate}}
      </button>
      <eyrus-question-type-list class="hide-sm hide-xs"
      (optionSelected)="handleSelection($event)"
      [questionTypes]="questionTypes">
      </eyrus-question-type-list>
    </div>
  </div>
</section>

<section class="main-box questionnaire-container questionnaire-holder"  *ngIf="questionList.length">
  <form [formGroup]="questionsForms" (ngSubmit)="onSubmit(questionsForms)">

    <div class="custom-container question-container" 
      formArrayName="questions"
      *ngFor="let question of questionsForms.get('questions').controls; let i = index;">

      <div class="group" [formGroupName]="i">
        <!-- Question title -->
        <div class="question-title capitalize hide-lg hide-md">
          Type: {{ question.get('questionType')?.value || '' }}
        </div>
        
        <div class="hide-sm hide-xs">
          <eyrus-question-type 
          [itemType]="question.get('questionTypeId')?.value"
          [questionTypes]="questionTypes"
          *ngIf="questionTypes.length && question.get('questionTypeId')?.value">
          </eyrus-question-type>
        </div>

        <!-- text question -->
        <div class="question-question-container text">
          <textarea
            formControlName="questionText"
            placeholder="{{ 'questionnaire.writeQuestionPlaceholder' | translate}}"></textarea>
        </div>

        <!-- Question options -->
        <div class="question-question-options-container"
          *ngIf="question.get('answerOptions')">

          <div class="form-group question-options" 
          formArrayName="answerOptions"
          *ngFor="let option of question.get('answerOptions').controls; let j = index;">

          <div [formGroupName]="j" class="w-full">
            <div class="form-group question-options">
              <input type="text" 
                class="form-control"
                formControlName="availableAnswerText"
                placeholder="{{'questionnaire.option' | translate}} {{ j + 1 }}">
  
              <div class="icon-holder m-l-sm cursor-pointer">
                <i  class="remove-teammate ae ae-recycle-bin" 
                  (click)="removeOption(i, j)">
                </i> 
              </div>
            </div>
          </div>

          </div>

          <div class="lay align-right m-b-md m-t-md"  *ngIf="question.get('answerOptions')">
            <button mat-raised-button 
              class="add-button grey-button" 
              color="secondary" 
              type="button"
              (click)="addOption(i)">
              <i class="ae ae-plus-bolt"></i>
              {{ "questionnaire.addOptions" | translate}}
            </button>
          </div>
        </div>
        
        <!-- Footer for each question -->
        <div class="question-footer">
          <div class="required-container">
            <mat-checkbox formControlName="required">
              {{ "common.required" | translate}} 
            </mat-checkbox>
          </div>
          <div class="icon-holder cursor-pointer">
            <i  class="remove-teammate ae ae-recycle-bin" 
              (click)="removeQuestion(i)">
            </i>      
          </div>
        </div>
      </div>
    </div>
  </form>

  <!-- Add question button -->
  <div class="gs align-left">
    <div class="lay">
      <div class="full-divider hide-sm hide-xs"></div>

      <button mat-raised-button 
        #addQuestion1
        class="add-button m-t-md hide-md hide-lg" 
        color="primary" 
        (click)="openQuestionAddModal()">
        <i class="ae ae-plus-bolt"></i>
        {{ "questionnaire.addQuestion" | translate}}
      </button>
      <eyrus-question-type-list class="hide-sm hide-xs"
        (optionSelected)="handleSelection($event)"
        [questionTypes]="questionTypes">
      </eyrus-question-type-list>

      <div class="full-divider hide-sm hide-xs"></div>
    </div>
  </div>

  <div class="buttons-row text-center">
    <button mat-raised-button class="md  m-r-md"
      color="primary"
      [disabled]="loading"
      (click)="onSubmit(questionsForms)">
      <span class="capitalize"> {{ "common.save" | translate }}  </span>
    </button>

    <button mat-stroked-button class="md"
      color="primary"
      [disabled]="loading"
      (click)="preview()">
      <span class="capitalize"> {{ "common.preview" | translate }}  </span>
    </button>
  </div>
</section>


<!-- Place holder for no questions -->
<section class="main-box questionnaire-container questionnaire-holder"  *ngIf="!questionList.length">
  <eyrus-no-results-placeholder
    [label]="'questionnaire.warnings.no-questions-created'"
    [displaySub]="false">
  </eyrus-no-results-placeholder>
</section>